export type FeatureFlagsStoreState = {
  isResolved: boolean;
};

const INITIAL_STATE: FeatureFlagsStoreState = {
  isResolved: false,
};

let state: FeatureFlagsStoreState = INITIAL_STATE;

const listeners = new Set<() => void>();

function emit() {
  for (const listener of listeners) {
    listener();
  }
}

export const featureFlagsStore = {
  subscribe: (listener: () => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },

  getSnapshot: () => state,
  getServerSnapshot: () => INITIAL_STATE,

  markResolved: () => {
    if (state.isResolved) {
      return;
    }
    state = { ...state, isResolved: true };
    emit();
  },

  reset: () => {
    state = { ...INITIAL_STATE };
    emit();
  },
};
